import styled from '@emotion/styled';
import { Box } from '../../../../Box';
import {
  stylesForDefaultState,
  stylesForFocusState,
  stylesForHoverState,
} from '../../../../_internal/theme/stylesFor';

const BaseThemeBox = styled(Box)`
  ${stylesForDefaultState('select')}

  &:hover {
    ${stylesForHoverState('select')}
  }

  &:focus {
    outline: 0;
    ${stylesForFocusState('select')}
  }
`;

export default BaseThemeBox;
